module.exports = __webpack_public_path__ + "img/PT.592f7014.png";